import { FeesRepo } from '../../fees.repo';
import * as moment from 'moment';
import * as _ from 'lodash';
import { FeeCalculationType } from '../../../common/enums/FeeCalculation'

class InstructionSheetController {

  // filter options
  public fromDate;
  public toDate;
  public searchFiltersList;

  public endOfLastMonth;
  public currentDate;
  public lastTwelveMonths ;

  // Calculation Type
  public displayMCB: boolean = true;

  public feeInstructions;

  public isLoading = false;

  public reloadInstructionSheets = false;


  /** @ngInject */
  constructor(private notifyjs, private $scope: angular.IScope, private feesRepo: FeesRepo, private $window: angular.IWindowService) {
    var date = new Date();
    this.currentDate = date;

    this.endOfLastMonth = moment(date).subtract(1, 'months').endOf('month');
    this.lastTwelveMonths = new Date(moment(date).subtract(18, 'months').endOf('month').format('YYYY-MM-DD'))

    this.searchFiltersList = [
      {
        name: "This Month",
        fromDate: moment(date).startOf('month').format('YYYY-MM-DD'),
        toDate: moment(date).endOf('month').format('YYYY-MM-DD'),
        active: false
      },
      {
        name: "Last Month",
        fromDate: moment(date).subtract(1, 'months').startOf('month').format('YYYY-MM-DD'),
        toDate: moment(date).subtract(1, 'months').endOf('month').format('YYYY-MM-DD'),
        active: false
      },
      {
        name: "Last Quarter",
        fromDate: moment().subtract(1, 'Q').startOf('quarter').format('YYYY-MM-DD'),
        toDate: moment().subtract(1, 'Q').endOf('quarter').format('YYYY-MM-DD'),
        active: false
      },
      {
        name: "First Quarter",
        fromDate: moment().quarter(1).startOf('quarter').format('YYYY-MM-DD'),
        toDate: moment().quarter(1).endOf('quarter').format('YYYY-MM-DD'),
        active: false
      },
      {
        name: "Second Quarter",
        fromDate: moment().quarter(2).startOf('quarter').format('YYYY-MM-DD'),
        toDate: moment().quarter(2).endOf('quarter').format('YYYY-MM-DD'),
        active: false
      },
      {
        name: "Third Quarter",
        fromDate: moment().quarter(3).startOf('quarter').format('YYYY-MM-DD'),
        toDate: moment().quarter(3).endOf('quarter').format('YYYY-MM-DD'),
        active: false
      },
      {
        name: "Fourth Quarter",
        fromDate: moment().quarter(4).startOf('quarter').format('YYYY-MM-DD'),
        toDate: moment().quarter(4).endOf('quarter').format('YYYY-MM-DD'),
        active: false
      },
      {
        name: "Last 12 Months",
        fromDate: moment(date).subtract(12, 'months').endOf('month').format('YYYY-MM-DD'),
        toDate: moment().add(-1, 'days').format('YYYY-MM-DD'),
        active: false
      }
    ]

    if (_.isEmpty(this.fromDate) || _.isEmpty(this.toDate)) {
      this.fromDate = new Date(this.searchFiltersList[0].fromDate);
      this.toDate = new Date(this.searchFiltersList[0].toDate);
      this.searchFiltersList[0].active = true;
      this.getFeeInstructionSheets()
    }
  }

  $onChanges(changes) {
    if (changes.reloadInstructionSheets) {
      this.getFeeInstructionSheets();
    }
  }


  toDateChanged = () => {
    _.forEach(this.searchFiltersList, (filterOption) => {
        filterOption.active = false
    });
    this.getFeeInstructionSheets();
  }

  fromDateChanged = () => {
    if(this.fromDate < this.toDate){
      _.forEach(this.searchFiltersList, (filterOption) => {
        filterOption.active = false
    });
    this.getFeeInstructionSheets();
    }
  }

  getFeeInstructionSheets = () => {
    let feeCalculationType = this.displayMCB ? FeeCalculationType.MCB : FeeCalculationType.EDR
    this.isLoading = true;
    let fromDate = moment(this.fromDate).startOf('month').format('YYYY-MM-DD');
    let toDate = moment(this.toDate).endOf('month').format('YYYY-MM-DD');
    this.feesRepo.getFeeInstructionSheets(fromDate, toDate, feeCalculationType)
      .then(res => {
        this.feeInstructions = [];
        this.feeInstructions = res.data as Array<any>;
      })
      .catch(err => {
        this.notifyjs("Could not load fee instructions")
      })
      .finally(() => this.isLoading = false)
  }




  convertToLocaleDate = (date: any) => {
    date = new Date(date)
    return moment(date).local().format('YYYY-MM-DD');
  }

  convertToLocaleDateTime = (date: any) => {
    date = new Date(date+'Z').toLocaleString()
    return moment(date).format('YYYY-MM-DD hh:mm:ss a');
  }



  downloadInstructionSheet = (sheet) => {
    this.feesRepo.downloadFeeInstruction(sheet.id)
      .then(res => {
        let instructionExcel = res.data as any;
        this.$window.open(instructionExcel.url, '_blank');

      })
      .catch(err => {
        this.notifyjs("Could not download excel " + err.data)
      })

  }


  formatDate(selectedDate) {
    return moment(selectedDate).endOf('month').format('YYYY-MM');
  }

  getAllFeeInstructionSheets = () => {
    this.fromDate = moment("2019-01-31").format('YYYY-MM-DD');
    this.toDate = moment(this.currentDate).subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
    this.getFeeInstructionSheets();
  }

}
export const instructionSheet: angular.IComponentOptions = {
  template: require('./fees.instructions.sheets.html'),
  controller: InstructionSheetController,
  bindings : {
    reloadInstructionSheets : "<"
  }
};



// WEBPACK FOOTER //
// ./src/app/fees/instructions/instructionSheets/fees.instructions.sheets.ts